<h3>
  <span *ngIf="!isEmpty(currentEmail.evt.content)">{{ 'agent:contact.workspace.mail.history.display_mail_content' | translate }}</span>
</h3>
<div
  noreset
  id="switchHtml{{ currentEmail.index }}"
  *ngIf="!isEmpty(currentEmail.evt.contentHtml) && currentEmail.isHtmlFormat"
  class="mailDescriptionPanelBody flex-column event-message"
>
  <div class="description" [innerHTML]="sanitizedHTML"></div>
</div>
<div
  id="switchTxt{{ currentEmail.index }}"
  *ngIf="!isEmpty(currentEmail.evt.content) && !currentEmail.isHtmlFormat"
  class="mailDescriptionPanelBody flex-column event-message"
>
  <div class="description description-txt">{{ currentEmail.evt.content }}</div>
</div>
<div class="switchHtml">
  <label for="switch{{ currentEmail.index }}">
    {{ 'agent:contact.workspace.mail.history.mail_format.text' | translate }}
    <cng-switch
      [switchValue]="currentEmail.isHtmlFormat"
      [switchId]="'switch{{currentEmail.index}}'"
      (switchChange)="switchContentFormat(currentEmail.evt.contentId)"
      title="{{ getFormattedContent(currentEmail.isHtmlFormat) }}"
    >
    </cng-switch>
    {{ 'agent:contact.workspace.mail.history.mail_format.html' | translate }}
  </label>
</div>
